module.exports = __webpack_public_path__ + "313ba3a4eb5400b689d1cceeba09cc1a.pdf";